"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _MediaContext = _interopRequireDefault(require("./MediaContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * connectToPlayer
 * @param Component
 * @returns Wrapped Component
 */
function connectToMedia(mapStateToProps) {
  if (mapStateToProps === void 0) {
    mapStateToProps = function mapStateToProps(state) {
      return state;
    };
  }

  return function (WrappedComponent) {
    // ...and returns another component...
    var Injector = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(Injector, _React$Component);

      function Injector() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

        _defineProperty(_assertThisInitialized(_this), "state", {});

        _defineProperty(_assertThisInitialized(_this), "subscription", null);

        return _this;
      }

      var _proto = Injector.prototype;

      _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;

        var store$ = this.context.$;
        this.subscription = store$.subscribe(function (nextState) {
          var mappedProps = mapStateToProps(nextState);
          var hasUpdates = Object.keys(mappedProps).some(function (prop) {
            return mappedProps[prop] !== _this2.state[prop];
          });

          if (hasUpdates) {
            _this2.setState(function (prevState) {
              return _extends({}, prevState, mappedProps);
            });
          }
        });
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        this.subscription.unsubscribe();
      };

      _proto.render = function render() {
        var actions = this.context.actions;
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, this.state, {
          onPlay: actions.playMedia,
          onPause: actions.pauseMedia,
          onSeek: actions.seekMedia,
          onSkipPrevNextHit: actions.skipPrevNextHit,
          onVolume: actions.setVolumeMedia,
          onSearch: actions.addQuery,
          onAddQuery: actions.addQuery,
          onRemoveQuery: actions.removeQuery,
          onChangeSentimentAnalyzer: actions.setSentimentAnalyzer,
          onChangeKeywordAnalyzer: actions.setKeywordAnalyzer,
          onChangePhraseSupportingAnalyzer: actions.setPhraseSupportingAnalyzer,
          onChangeVerbNounAnalyzer: actions.setVerbNounAnalyzer,
          onChangeEntitiesAnalyzer: actions.setEntitiesAnalyzer,
          onPlaybackSpeedChange: actions.setPlaybackSpeed
        }, this.props));
      };

      return Injector;
    }(_react["default"].Component);

    _defineProperty(Injector, "contextType", _MediaContext["default"]);

    return Injector;
  };
}

var _default = connectToMedia;
exports["default"] = _default;